import { ReactNode, useEffect, useState } from 'react';
import { useAuth } from '../contexts/AuthContext';
import Login from './Login';
import ChangePasswordModal from './ChangePasswordModal';

interface ProtectedRouteProps {
  children: ReactNode;
  requiredPermission?: string;
}

export default function ProtectedRoute({ children, requiredPermission }: ProtectedRouteProps) {
  const { user, isLoading, hasPermission } = useAuth();
  const [forcePwd, setForcePwd] = useState(false);

  useEffect(() => {
    if (user?.mustChangePassword) {
      setForcePwd(true);
    }
  }, [user?.mustChangePassword]);

  // Show loading state
  if (isLoading) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        fontSize: '1.25rem',
        color: '#6b7280'
      }}>
        Loading...
      </div>
    );
  }

  // Not logged in - show login
  if (!user) {
    return <Login />;
  }

  // Check permission if required
  if (requiredPermission && !hasPermission(requiredPermission)) {
    return (
      <div style={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        flexDirection: 'column',
        gap: '1rem',
        padding: '2rem',
        textAlign: 'center'
      }}>
        <h2 style={{ margin: 0, color: '#991b1b' }}>⛔ Access Denied</h2>
        <p style={{ margin: 0, color: '#6b7280' }}>
          You don't have permission to access this feature.
        </p>
        <p style={{ margin: 0, fontSize: '0.875rem', color: '#9ca3af' }}>
          Required permission: <strong>{requiredPermission}</strong>
        </p>
      </div>
    );
  }

  return <>
    {children}
    {forcePwd && (
      <ChangePasswordModal
        force
        onClose={() => { /* cannot close without success */ }}
        onSuccess={() => { setForcePwd(false); }}
      />
    )}
  </>;
}
